import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { transactionAPI } from "services";
import { formatDate, formatMoney } from "utils";
import ModalImage from "react-modal-image";
import { confirm } from "components";
import useUniversalStore from "store/universalStore";
import useOffcanvasStore from "store/offcanvasStore";
import { toast } from "sonner";

const Txn = ({ data, setLoading, handleToggle }) => {
  const { accountId, write, selectedMonth } = useUniversalStore((state) => state);

  const isPDF = data.get("attachment")?.includes(".pdf");
  const isImage = data.get("attachment")?.match(/\.(jpg|jpeg|png|gif|webp)$/i);
  const navigate = useNavigate();
  const { openOffcanvas } = useOffcanvasStore();
  const text = data.get("detail");

  const handleModalOpen = () => {
    confirm({
      message: "You want to delete this <b>Transaction</b>",
      onConfirm: () => deleteTransaction(data.id),
    });
  };

  //method to navigate home page and auto select the khatha account
  const openKhataView = async () => {
    const accountId = data?.get("accountId")?.id;
    if (!accountId) return;

    if (data.get("accountId")?.get("cancelled")) {
      toast.error("Account is Closed");
      return;
    };
    write({ accountId: accountId });
    navigate("/khatabook");
  };

  const deleteTransaction = async (id) => {
    try {
      setLoading(true)
      await transactionAPI.deleteTransaction(id);
      //Reset the transactionId
      write({
        transactionId: null,
        transactions: await transactionAPI.getTransactionsByDate(selectedMonth)
      });
      handleToggle(false);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false)
    }
  }

  const cancelledView = () => {
    return (
      <div className="d-flex w-100 p-0 m-0 align-items-stretch" style={{ minHeight: '52px' }}>
        <div className="col-md-3 p-1 d-flex align-items-center justify-content-end" style={{ flexShrink: 0 }}>
          <span className="fs-xmd-smaller text-nowrap text-decoration-line-through text-muted">
            {formatMoney(data.get("amount"))}
          </span>
        </div>
        <div className="col-md-9 p-1 ps-2 d-flex flex-column justify-content-center text-start position-relative">
          {data.get("accountId") ? (
            <div className="text-decoration-line-through text-muted pe-none fw-bold" style={{ fontSize: '0.85rem', lineHeight: '1.2' }}>
              {data.get("accountId")?.get("name")}
            </div>
          ) : null}
          <div className="text-decoration-line-through text-muted" style={{ fontSize: '0.75rem', lineHeight: '1.2', marginTop: '2px' }}>
            <span className="text-break text-wrap">{data.get("detail")}</span>
          </div>
        </div>
      </div>
    );
  };

  const normalView = () => {
    return (
      <>
        <div className="d-flex w-100 p-0 m-0 align-items-stretch position-relative" style={{ minHeight: '52px' }}>
          <div className="d-flex align-items-center justify-content-end col-md-3" style={{ minWidth: "50px" }} >
            <span className="fs-xmd-smaller text-nowrap text-dark">
              {formatMoney(Math.abs(data.get("amount")))}
            </span>
          </div>
          <div className="col-8 col-sm-9 p-1 ps-2 ps-md-3 pb-2 d-flex flex-column justify-content-center text-start position-relative">
            <div className="position-absolute py-1 px-1 top-0 end-0">
              <div className="dropdown">
                <a
                  className="text-black btn p-0 p-md-1 bg-not-transparent-on-hover w-auto"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  title="More options"
                >
                  <span className="bi bi-three-dots-vertical"></span>
                </a>
                <ul className="dropdown-menu dropdown-menu-end row w-auto">
                  <li className="col-12 py-1">
                    <button className="w-100 btn btn-outline-app rounded"
                      onClick={() => {
                        write({ transactionId: data.id })
                        openOffcanvas("editTxn")
                      }}
                    >
                      <span className="bi bi-pencil-fill"> Edit</span>
                    </button>
                  </li>
                  <li className="col-12 py-1">
                    <button
                      className="w-100 btn btn-app rounded"
                      onClick={() => {
                        write({ transactionId: data.id })
                        handleModalOpen()
                      }}
                    >
                      <span className="bi bi-trash"> Delete</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <div className="pe-3">
              {data.get("accountId") ? (
                <a onClick={openKhataView}
                  type="button"
                  className="text-decoration-none text-dark fw-bold d-block fs-xmd-smaller select-none">
                  {data.get("accountId")?.get("name")}
                </a>
              ) : null}
              <div className="text-dark fs-xmd-smaller">
                <span className="text-break text-wrap">{text}</span>
              </div>

            </div>
          </div>
        </div>
        {(isImage || isPDF) && (
          <div className="col-6 mx-auto p-0 my-1">
            {isPDF && (
              <a role="button" href={data.get("attachment")} target="_blank" rel="noreferrer" className="cursor-pointer d-inline-block">
                <i className="bi bi-file-pdf-fill text-danger fs-5" />
              </a>
            )}
            {isImage && (
              <div className="d-inline-block">
                <ModalImage
                  small={data.get("attachment")}
                  large={data.get("attachment")}
                  hideDownload={false}
                  hideZoom={false}
                  className="uploadbillpreview rounded border shadow-sm"
                />
              </div>
            )}
          </div>
        )}
      </>
    );
  };

  return (
    <div className="list-group-item bg-transparent p-0 border-bottom">
      {data.get("cancelled") ? cancelledView() : normalView()}
    </div>
  );
}

export default Txn;
